import React from 'react';
import './reclamos.css';
import FormularioReclamo from '../layout/layout-reclamos/formulario-reclamo';

export default function Reclamos() {

  return <FormularioReclamo/>
}